import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'outlook-integration-dialog',
  templateUrl: 'outlook-integration-dialog.component.html',
  styleUrl: 'outlook-integration-dialog.component.scss',
  imports: [MatDialogModule, MatButtonModule, MatIconModule, MatRadioModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OutlookIntegrationDialog {
  private readonly snackbar = inject(MatSnackBar);

  readonly $calendarUrl = input.required<string>({
    alias: 'calendarUrl',
  });

  protected async copyCalendarUrlToClipboard() {
    const copySuccess = await navigator.clipboard
      .writeText(this.$calendarUrl())
      .then(() => true)
      .catch(() => false);
    const snackbarMsg = copySuccess
      ? 'Link copied to clipboard'
      : 'Failed to copy to clipboard';
    this.snackbar.open(snackbarMsg, undefined, { duration: 800 });
  }
}
